import React, { useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { RenderIf } from '../../utils/RenderIf';
import { PromotionsFechtAPI } from '../../../api/Promotions';
import { GroupsFechtAPI } from '../../../api/Groups';
import { TaxesFetchAPI } from '../../../api/Taxes';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import defaultImage from "../../../assets/img/default.png"

function ModalCreatePromotion({ loadPromotions }) {
    const [showModal, setShowModal] = useState(false)
    const [imgpreview, setImgpreview] = useState('')
    const [groups, setGroups] = useState([])
    const [taxes, setTaxes] = useState([])
    const [taxesSelect, setTaxesSelect] = useState([])
    const formRef = useRef(null)
    let token = localStorage.getItem("x-access-token")

    let user = localStorage.getItem('user');


    //Function to register the product 
    const submit = async (e) => {
        e.preventDefault();
        user = JSON.parse(localStorage.getItem('user'))
        const form = new FormData(e.target);
        form.append("business_id", user.business_id);
        const createPromotion = Object.fromEntries(form.entries());
        createPromotion.taxes = [...new Set(taxesSelect)]


        console.log(createPromotion);
        try {
            //We update the data 
            await PromotionsFechtAPI.createPromotion(createPromotion, token);
            //We show the success alert 
            resetForm()
            ErrorAlert('', 'Promocion creada con exito', 'success')
            loadPromotions();
            setShowModal(false);
        } catch (err) {
            ErrorAlert(err.response.data.error, 'Error de registro', 'error')
            console.log(err.response.data.error)
        }
    }

    const getGroupsByBusiness = async() =>{
        user = JSON.parse(localStorage.getItem('user'))
        try{
            const response = await GroupsFechtAPI.getGroupsByBusiness(user.business_id, token)
            console.log(response);
            setGroups(response.data.data)
        }catch(err){
            console.log(err);
        }
    }

        //filter checkbox in state true and save in state array
    const getChecked = (event) => {
        let dataTaxes = JSON.parse(event.target.value)
        if (event.target.checked === true) {
            setTaxesSelect((previousTaxes) => [...new Set([...previousTaxes, dataTaxes])])
        } else if (event.target.checked === false) {
            setTaxesSelect((previousTaxes) => previousTaxes.filter((taxId) => taxId !== dataTaxes))
        }
    }

    const resetForm = () => {
        setTaxesSelect([])
        setImgpreview('')
        formRef.current?.reset()
    }

    const openModal = () => {
        resetForm()
        setShowModal(true)
        getGroupsByBusiness()
        getTaxes()
    }

    const closeModal = () => {
        resetForm()
        setShowModal(false)
    }

    const getTaxes = async () => {
        try {
            const response = await TaxesFetchAPI.getTaxes(token);
            setTaxes(response.data.data)

        } catch (err) {
            console.log(err);
        }
    }

    const changeimg = (e) => {
        setImgpreview(URL.createObjectURL(e.target.files[0]))
    }

    return (
        <>
            <div><button className='btn btn-dark btn-sm  fw-normal bg-body text-dark border border-1 rounded-2' onClick={openModal} ><i className="uil uil-plus-circle"></i> Nueva</button></div>

            <Modal
                show={showModal}
                onHide={closeModal}
                size='large'
                centered>
                <Modal.Header className='text-center'>
                    <h3>
                        <i className="uil uil-apps"></i>
                        Nueva promocion </h3>
                </Modal.Header>
                <Modal.Body>
                    <RenderIf isTrue={imgpreview !== ''}>
                        <div className='d-flex align-item-center justify-content-center'>
                            <img
                                className='imgEditModal'
                                src={imgpreview ? buildCloudinaryImageUrl({ url: imgpreview, width: 250, quality: "auto", type: "image" }) : defaultImage}
                                alt="Imagen de la promoción"
                                loading='lazy'
                                />
                        </div>

                        <div className='d-flex align-item-center justify-content-center m-3'>
                            <label htmlFor="upload-button">
                                <h5 className="text-center">Seleccione una imagen</h5>
                            </label>
                        </div>
                    </RenderIf>


                    <Form
                        ref={formRef}
                        className="needs-validation"
                        onSubmit={submit}
                    >

                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nombre del producto"
                                name="name"
                                required
                                
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Precio</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="$0.00"
                                name="price"
                                required
                                
                            />
                        </Form.Group>


                        <Form.Group className="mb-3" >
                            <Form.Label>Decripcion</Form.Label>
                            <Form.Control as="textarea" rows={3}
                                placeholder="Descripcion del producto"
                                name="description"
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Fecha de expiracion</Form.Label>
                            <Form.Control
                                type="date"
                                placeholder="Descripcion del producto"
                                name="expirationDate"
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Producto</Form.Label>
                            <Form.Select aria-label="" name="product" >
                                <option>Seleccione un producto</option>
                                {groups.map(
                                    group => (
                                    <option value={group.group_id}>{group.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Impuestos </Form.Label>
                            <div>
                                {taxes.map((tax, index) => (
                                    <>
                                        <Form.Check
                                            inline
                                            label={tax.tax}
                                            name="taxes"
                                            type='checkbox'
                                            value={JSON.stringify(tax.id)}
                                            checked={taxesSelect.some((taxId) => taxId === tax.id)}
                                            onChange={(e) => getChecked(e)}
                                            id={`tax${tax.id}`}
                                        />
                                    </>
                                ))}
                            </div>
                        </Form.Group>
                 

                        <Form.Group controlId="formFileMultiple" className="mb-3">
                            <Form.Label></Form.Label>
                            <Form.Control type="file"
                                id="upload-button"
                                placeholder="Imagen"
                                name="files"
                                onChange={(e) => changeimg(e)}
                                required />
                        </Form.Group>


                        <div className="mt-3 d-flex justify-content-end">
                            <Button size="sm" variant="success" type="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={closeModal}>Cerrar</Button>
                </Modal.Footer>
            </Modal >

        </>
    )
}

export default ModalCreatePromotion
